export const getBuildTimeEnv = (): Record<string, string | undefined> =>
  import.meta.env as unknown as Record<string, string | undefined>;
